// extracted by mini-css-extract-plugin
export default {"layout":"U1E8n","content":"fW4Me","about":"ss5rb","subtitle":"iHvIb","title":"ucYLo","description":"GUH20"};